// @flow
import { getObjectId } from '@ta/common.global';
/**
 * Creates the report props from a "standard" UGC object.
 *
 * Handles corner cases like reposts, etc.
 */
const reportPropsFromObject = (contentObject: any): any => {
  const contentId = getObjectId(contentObject);

  const baseProps = {
    contentId,
    location: contentObject.location,
    forumInfo: { forumId: contentObject.forumId, forumTopicId: contentObject.topicId },
  };

  const { repostedObject } = contentObject;
  if (!repostedObject) {
    return baseProps;
  }

  const originalId = getObjectId(repostedObject);
  return {
    ...baseProps,
    location: repostedObject.location,
    forumInfo: { forumId: repostedObject.forumId, forumTopicId: repostedObject.topicId },
    repostInfo: { originalId, originalType: repostedObject.__typename },
  };
};

export default reportPropsFromObject;
